<mat-card>
  <mat-card-title> <mat-icon>flight_takeoff</mat-icon> My Open Flights </mat-card-title>
  <mat-divider></mat-divider>
  <mat-card-content>
    <fl-flight-log-highlights-table
      [flightLogs]="flightLogs$"
      [columns]="columns"
      (sort)="onSort($event)"
      (flightLogDeleted)="refresh(2000)"
      (flightLogRestored)="refresh(2000)"
    ></fl-flight-log-highlights-table>
    <mat-paginator [pageSize]="defaultPageSize" [length]="total$ | async" (page)="onPage($event)">
    </mat-paginator>
  </mat-card-content>
  <mat-card-actions position="end">
    <a routerLink="/flight-logs/create" [queryParams]="{ mode: 'Simple' }" mat-button
      >Log External</a
    >
    <a routerLink="/flight-logs" mat-button>All My Flights</a>
    <a mat-button color="primary" (click)="openFindFlightDialog()">I can't find my flight</a>
  </mat-card-actions>
</mat-card>
